import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUsersWithoutMentorGroups } from 'actions/user';
import { DataList, Spinner } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { translate } from '@haldor/ui';

var UsersWithoutMentorGroups = /*#__PURE__*/function (_Component) {
  _inherits(UsersWithoutMentorGroups, _Component);

  var _super = _createSuper(UsersWithoutMentorGroups);

  function UsersWithoutMentorGroups(props) {
    var _this;

    _classCallCheck(this, UsersWithoutMentorGroups);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.props.getUsersWithoutMentorGroups();

            case 2:
              _this.setState({
                loading: false
              });

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "renderStudent", function (student) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: student.userId,
        target: "/user/".concat(student.userId, "/progress")
      }, /*#__PURE__*/React.createElement(RowCell, {
        title: _this.props.translate('Name')
      }, student.firstName, " ", student.lastName));
    });

    _this.state = {
      loading: true
    };
    return _this;
  }

  _createClass(UsersWithoutMentorGroups, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement(DataList, {
        data: this.props.usersWithoutMentorGroups,
        renderRow: this.renderStudent,
        emptyData: function emptyData() {
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
            style: {
              textAlign: 'center'
            }
          }, _this2.props.translate('no-results')));
        }
      });
    }
  }]);

  return UsersWithoutMentorGroups;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    usersWithoutMentorGroups: state.user.usersWithoutMentorGroups
  };
}

export default connect(mapStateToProps, {
  getUsersWithoutMentorGroups: getUsersWithoutMentorGroups
})(UsersWithoutMentorGroups);